import { ReactToExerciseEventType, StartExercise, UpdateObjective } from "Phaser/EventBus";
import Tutorial, { ChapterType, ExerciseScene } from "Types/ExerciseData";
import { AddEventsAndMergeTimestamps, Timestamps } from "Utils/ChaptersToTimestamps";
import timestamps from "./level9.json";

// This is still using the old JSON way of defining levels
const Level9: Tutorial = {
  level: 9,
  end: '3:13',
  videoUrl: 'level-9.mp4',
  sections: [{
    chapters: [
      {
        title: 'Introduction to 2-Part Harmony',
        start: '0:00',
        data: [ChapterType.Lecture]
      },
    ]
  },
  {
    chapters: [
      {
        title: 'Oblique Motion',
        start: '0:49',
        data: [ChapterType.Lecture]
      },
      {
        title: 'Oblique Motion',
        start: '1:03',
        data: [
          ChapterType.Exercise,
          {
            scene: [
              ExerciseScene.NoTimeExercise,
              {
                centre_align_horizontal: true,
                padding_x: 700,
                objectives: [
                  {
                  },
                ],
              },
            ],
            events: [
            ],
          }
        ]
      },
      {
        title: 'Parallel Motion',
        start: '1:11',
        data: [ChapterType.Lecture]
      },
      {
        title: 'Parallel Motion',
        start: '1:28',
        data: [
          ChapterType.Exercise,
          {
            scene: [
              ExerciseScene.NoTimeExercise,
              {
                centre_align_horizontal: true,
                padding_x: 700,
                objectives: [
                  {
                  },
                ],
              },
            ],
            events: [
            ],
          }
        ]
      },
      {
        title: 'Contrary Motion',
        start: '1:32',
        data: [ChapterType.Lecture]
      },
      {
        title: 'Contrary Motion',
        start: '1:45',
        data: [
          ChapterType.Exercise,
          {
            scene: [
              ExerciseScene.NoTimeExercise,
              {
                centre_align_horizontal: true,
                padding_x: 700,
                objectives: [
                  {
                  },
                ],
              },
            ],
            events: [
            ],
          }
        ]
      },
      {
        title: 'Combined Motion',
        start: '1:49',
        data: [ChapterType.Lecture]
      },
      {
        title: 'Combined Motion',
        start: '2:00',
        data: [
          ChapterType.Exercise,
          {
            scene: [
              ExerciseScene.NoTimeExercise,
              {
                centre_align_horizontal: true,
                padding_x: 700,
                objectives: [
                  {
                  },
                ],
              },
            ],
            events: [
            ],
          }
        ]
      },
    ]
  },
  {
    chapters: [
      {
        title: 'Whole Note Pairs',
        start: '2:05',
        data: [
          ChapterType.Exercise,
          {
            scene: [
              ExerciseScene.StaffExercise,
              {
                objectives: [
                  {
                  },
                  {
                  },
                ],
              },
            ],
            events: [
            ],
          }
        ]
      },
      {
        title: 'Playing Whole + Half Notes',
        start: '2:25',
        data: [ChapterType.Lecture]
      },
      {
        title: 'Whole + Half Notes',
        start: '2:57',
        data: [
          ChapterType.Exercise,
          {
            scene: [
              ExerciseScene.StaffExercise,
              {
                firstObjectiveAppearDelay: 500,
                objectives: [
                  {
                  },
                  {
                  },
                ],
              },
            ],
            events: [
            ],
          }
        ]
      }
    ]
  }
  ]
};
export default AddEventsAndMergeTimestamps(timestamps as Timestamps, Level9);
